export default __webpack_public_path__ + "ab2adc26e454390cc2321e80cb5494a4.webp";